import { useState } from 'react';
import Fab from '@mui/material/Fab';

import AddIcon from '@mui/icons-material/Add';
import { useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useMutation } from '@tanstack/react-query';
import CreateShiftFormDialog from '~/components/CreateShiftForm';
import messages from './messages';
import { shiftsPost } from '~/generated';
import { extractData } from '~/utils/query-utils';

type CreateShiftButtonProps = {
  // the week in which the shift should be created
  date: string;
};

const CreateShiftButton = (props: CreateShiftButtonProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [isShiftCreationDialogVisible, setShiftCreationDialogVisibility] =
    useState(false);
  const mutation = useMutation({
    mutationKey: ['shifts', 'create'],
    mutationFn: (values: { startDate: string; endDate: string }) =>
      extractData(shiftsPost({ body: values, responseType: 'json' })),
    onSuccess() {
      setShiftCreationDialogVisibility(false);
      showSnackbar({
        message: intl.formatMessage(messages.shiftCreationSucceeded),
      });
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.shiftCreationFailed),
      });
    },
  });
  return (
    <>
      <Fab
        color="secondary"
        aria-label={intl.formatMessage(messages.label)}
        sx={(theme) => ({
          position: 'absolute',
          bottom: theme.spacing(2),
          right: theme.spacing(4),
        })}
        onClick={() => {
          setShiftCreationDialogVisibility(true);
        }}
      >
        <AddIcon />
      </Fab>
      {isShiftCreationDialogVisible ? (
        <CreateShiftFormDialog
          onSubmit={(values) =>
            mutation.mutate({
              startDate: `${values.startDate}T${values.startTime}:00`,
              endDate: `${values.endDate}T${values.endTime}:00`,
            })
          }
          open={isShiftCreationDialogVisible}
          onClose={() => setShiftCreationDialogVisibility(false)}
          date={props.date}
        />
      ) : null}
    </>
  );
};

export default CreateShiftButton;
